import { createBooleanDevicePreference } from './devicePreference';

// Per-device toggle for the in-workout target meter (AP-3b): the contextual
// weekly-target strip at the top of the logger's active-exercise card. Default
// ON; the Settings style card offers the off switch. Off → the hook skips the
// fold and the strip renders nothing, so it never occupies space above the set
// controls for athletes who don't want it.
const pref = createBooleanDevicePreference(
  'jackedlogs.inWorkoutMeter.v1.enabled',
  true,
);

export const useInWorkoutMeterEnabled = pref.usePreference;
